import { render, staticRenderFns } from "./Licensing.vue?vue&type=template&id=f73eea36&scoped=true&"
import script from "./Licensing.vue?vue&type=script&lang=js&"
export * from "./Licensing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73eea36",
  null
  
)

export default component.exports